import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter , Routes , Route} from 'react-router-dom';
import Home from './pages/home';
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/main.css';
import LoadingState from './components/LoadingState';

// Every page except the home feed loads on demand, so visitors only download
// the code for the page they open (the editor, AI tools and email widget are heavy).
const About = lazy(() => import('./pages/about'));
const Create = lazy(() => import('./pages/createBlog'));
const Edit = lazy(() => import('./pages/editBlog'));
const PageNotFound = lazy(() => import('./pages/PageNotFound'));
const Auth = lazy(() => import('./pages/auth'));
const Support = lazy(() => import('./pages/support'));
const ViewBlog = lazy(() => import('./pages/viewBlog'));
const Settings = lazy(() => import('./pages/settings'));
const SearchPage = lazy(() => import('./pages/search'));
const AI = lazy(() => import('./pages/ai'));
const Profile = lazy(() => import('./pages/profile'));
const AuthorPage = lazy(() => import('./pages/author'));
const Videos = lazy(() => import('./pages/videos'));
const UploadVideo = lazy(() => import('./pages/uploadVideo'));
const WatchVideo = lazy(() => import('./pages/watchVideo'));
const EditVideo = lazy(() => import('./pages/editVideo'));
const Channels = lazy(() => import('./pages/channels'));
const ChannelPage = lazy(() => import('./pages/channel'));
const ManageChannel = lazy(() => import('./pages/manageChannel'));
const Library = lazy(() => import('./pages/library'));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Suspense fallback={<LoadingState label="Loading page" />}>
      <Routes>
          <Route exact path='/' element={<Home/>} />
          <Route exact path='/create' element={<Create/>} />
          <Route exact path='/edit' element={<Edit/>} />
          <Route exact path='/about' element={<About/>} />
          <Route exact path='/auth' element={<Auth/>} />
          <Route exact path='/support' element={<Support/>} />
          <Route exact path='/viewBlog' element={<ViewBlog/>} />
          <Route exact path='/settings' element={<Settings/>} />
          <Route exact path='/profile' element={<Profile/>} />
          <Route exact path='/author' element={<AuthorPage/>} />
          <Route exact path='/videos' element={<Videos/>} />
          <Route exact path='/uploadVideo' element={<UploadVideo/>} />
          <Route exact path='/watch' element={<WatchVideo/>} />
          <Route exact path='/editVideo' element={<EditVideo/>} />
          <Route exact path='/channels' element={<Channels/>} />
          <Route exact path='/channel' element={<ChannelPage/>} />
          <Route exact path='/manageChannel' element={<ManageChannel/>} />
          <Route exact path='/library' element={<Library/>} />
          <Route exact path='/search' element={<SearchPage/>} />
          
          <Route exact path='/ai' element={<AI/>} />
          <Route exact path='/*' element={<PageNotFound/>} />
      </Routes>
      </Suspense>

    </BrowserRouter>
  </React.StrictMode>
);

